"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var map_types_1 = require("../map.types");
var lodash_1 = __importDefault(require("lodash"));
var cluster_radius_1 = require("./cluster-radius");
function createCluster(zoomFactor, installationsInCluster) {
    return {
        id: lodash_1.default.uniqueId('cluster_'),
        radius: cluster_radius_1.clusterRadius[zoomFactor],
        type: map_types_1.MapInstallationType.CLUSTER,
        installationsInCluster: installationsInCluster,
        get location() {
            var aggregatePosition = this.installationsInCluster.reduce(function (aggregate, current) {
                return {
                    longitude: aggregate.longitude + current.location.longitude,
                    latitude: aggregate.latitude + current.location.latitude,
                };
            }, { longitude: 0, latitude: 0 });
            return {
                longitude: aggregatePosition.longitude / this.installationsInCluster.length,
                latitude: aggregatePosition.latitude / this.installationsInCluster.length,
            };
        },
    };
}
exports.createCluster = createCluster;
//# sourceMappingURL=create-cluster.js.map